import React from 'react';
import { motion } from 'framer-motion';

const stats = [
  { value: '6', label: 'Weeks to Results' },
  { value: '15%', label: 'Avg. Body Weight Lost' },
  { value: '100%', label: 'Results Guarantee' },
  { value: '98%', label: 'Client Satisfaction' },
];

const StatsBar = () => (
  <section className="py-12 bg-stone-900 relative overflow-hidden">
    <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(217,119,6,0.12),transparent_70%)]" />
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-4">
        {stats.map((stat, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.1 }}
            className="text-center border-r border-stone-800 last:border-0 px-4"
          >
            <p className="text-3xl md:text-4xl font-black text-amber-400 font-serif mb-1">{stat.value}</p>
            <p className="text-stone-400 text-xs uppercase tracking-widest font-bold">{stat.label}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default StatsBar;